<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/>
    <path d="M12 8V8.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M12 11V16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>
